export default __webpack_public_path__ + "static/media/hotel-resort-bg-01.4e0d1cc5.jpg";